export default "__VITE_ASSET__DqvD7O7P__"